import { useApiPostQuery } from 'mf_core/query';

export function usePNAetaWarehouseDetails(
  sku: string,
  productType?: string,
  vendorCode?: string,
  getDetailedPreorderEta?: boolean
) {
  return useApiPostQuery<PNAResponse>(
    '/pricing-and-availability/v1/pnas?pnaFilters=includeAvailability=true,includePricing=false,includeProductAttributes=true,includeDiscounts=false',
    {
      getDetailedPreorderEta: getDetailedPreorderEta,
      item: [
        {
          ingramPartNumber: sku,
          skuType: productType,
          vendorCode: vendorCode,
        },
      ],
    },
    undefined,
    undefined,
    { 'IM-MicroFrontendID': 'cep_ETA_availability' }
  );
}

export type PnaRequest = {
  item: {
    ingramPartNumber: string;
  };
};

type PNAResponse = [
  {
    inStockProducts: InStockProducts[];
    onOrderProducts: OnOrderProducts[];
    preOrderStockDetails: any;
  }
];

type InStockProducts = {
  eta: string;
  leadDaysLowerBoundary: number;
  leadDaysUpperBoundary: number;
  partNumber: string;
  quantity: number;
};

type OnOrderProducts = {
  eta: string;
  leadDaysLowerBoundary: number;
  leadDaysUpperBoundary: number;
  partNumber: string;
  quantity: number;
  reservedQuantity: number;
};
